export default __webpack_public_path__ + "static/media/34t.bed2f3b2.jpg";